<template>
  <aside id="bodysidebar" class="main-sidebar sidebar-dark-warning elevation-4">
    <!-- Brand Logo -->
    <a class="brand-link">
      <img
        src="@/views/assets/img/template/LogoUpla5.png"
        class="brand-image img-circle elevation-2"
      />
      <span class="brand-text font-weight-white">PROYECCIÓN SOCIAL</span>
    </a>

    <!-- Sidebar -->
    <div class="sidebar">
      <div class="user-panel mt-3 pb-3 mb-3 d-flex align-items-center justify-content-center">
        <div class="image">
          <img
            v-bind:src="
              'https://academico.upla.edu.pe/PhotD/' + Codigo + '.jpg'
            "
            class="img-circle elevation-3"
            alt="User Image"
            @error="replaceByDefault"
          />
        </div>
        <div class="info pl-3">
          <a class="d-block">{{ Nombres }}</a>
          <a class="d-block">{{ this.ApellidoP }} {{ this.ApellidoM }}</a>
          <a class="d-block text-left">DNI: {{ Codigo }}</a>
          <a class="d-block text-left">PROYECCIÓN SOCIAL</a>
        </div>
      </div>


      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul
          class="nav nav-pills nav-sidebar flex-column nav-flat nav-legacy"
          data-widget="treeview"
          role="menu"
          data-accordion="false"
        >
          <nav-item
            v-for="value in ListarMenu"
            :key="value.id"
            :icon="value.icono"
            :link="value.url"
            v-show="!value.subMenu"
          >
            {{ value.titulo }}
          </nav-item>

          <li
            class="nav-item is-opening menu-open"
            v-for="value in ListarMenu"
            :key="value.id"
            v-show="value.subMenu"
          >
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-book"></i>
              <p>
                {{ value.titulo }}
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview ">
              <nav-item
                v-for="valor in value.subMenuItems"
                :key="valor.id"
                icon="far fa-circle nav-icon"
                :link="valor.url"
              >
                {{ valor.titulo }}
              </nav-item>
            </ul>
          </li>

          <!-- <li class="nav-item" data-v-43319abc=""><a href="#" class="nav-link" data-v-43319abc="">
            <i class="nav-icon fas fa-book" data-v-43319abc=""></i>
            <p data-v-43319abc="">Reportes <i class="right fas fa-angle-left" data-v-43319abc=""></i></p></a>
            <ul class="nav nav-treeview is-opening menu-open" data-v-43319abc=""><li class="nav-item" data-v-43319abc="">
              <a href="/reportes" class="nav-link"><i class="nav-icon far fa-circle nav-icon"></i><p>Reportes</p></a></li></ul>
            </li>

            <li class="nav-item menu-is-opening menu-open" data-v-43319abc=""><a href="#" class="nav-link" data-v-43319abc="">
              <i class="nav-icon fas fa-book" data-v-43319abc=""></i>
              <p data-v-43319abc="">Reportes <i class="right fas fa-angle-left" data-v-43319abc=""></i></p></a>
              <ul class="nav nav-treeview is-opening menu-open" data-v-43319abc="" style="display: block;">
                <li class="nav-item" data-v-43319abc=""><a href="/reportes" class="nav-link">
                  <i class="nav-icon far fa-circle nav-icon"></i><p>Reportes</p></a></li></ul>
              </li> -->




          <!-- <nav-item icon="fas fa-file-export" link="/seguimiento2">
            Resolucion
          </nav-item> -->
          <!-- <nav-item icon="fas fa-file-export" link="/crear">
            Crear Resolución
          </nav-item> -->
          <!-- <nav-item icon="fas fa-file-export" link="/seguimientoestudiantes">
            Seguimiento
          </nav-item>  -->
          <!-- <nav-item icon="fas fa-user-plus" link="/autoridades">
            Autoridades
          </nav-item> -->
          <!-- <nav-item icon="fas fa-file" link="/revision">
            Revision de proyectos
          </nav-item> -->
          <!-- <nav-item icon="fas fa-info-circle" link="/about">
            About
          </nav-item> -->
          <!-- <nav-item icon="fas fa-users" link="/docentes">
            Docentes
          </nav-item> -->
          <!-- <div class="form-group">
            <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
              <input type="checkbox" class="custom-control-input" id="customSwitch3">
            <label class="custom-control-label" for="customSwitch3">Toggle this custom switch element with custom colors danger/success</label>
            </div>
          </div> -->
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
  </aside>
</template>

<script>
import NavItem from "./NavItem.vue";
export default {
  data() {
    return {
      Codigo: sessionStorage.getItem("codigo"),
      ApellidoP: sessionStorage.getItem("ApellidoP"),
      ApellidoM: sessionStorage.getItem("ApellidoM"),
      Nombres: sessionStorage.getItem("Nombres"),
      Rol: sessionStorage.getItem("Rol"),
      ListarMenu: null,
    };
  },
  components: {
    NavItem,
  },

  methods: {
    replaceByDefault(e) {
      e.target.src = `https://avatars.dicebear.com/api/initials/${this.Nombres}.svg?b=%23017cbc`;
    },

    async obtenerMenu() {
      await this.axios
        .get("https://aplicaciones.upla.edu.pe:42000/obtenerMenu/4")
        .then((response) => {
          this.ListarMenu = response.data;
          console.log(this.ListarMenu)
        });
    },
  },

  mounted() {
    // console.log(this.Nombres)
    this.obtenerMenu();
  },
};
</script>



<style scoped>
.main-sidebar {
  background-color: #324452;
}

#checkboxDark {
  position: absolute; /*El div será ubicado con relación a la pantalla*/
  left: 110px; /*A la derecha deje un espacio de 0px*/
  right: 0px; /*A la izquierda deje un espacio de 0px*/
  bottom: 0px; /*Abajo deje un espacio de 0px*/
  height: 30px; /*alto del div*/
  z-index: 0;
}

.circular--portrait {
  position: relative;
  width: 130px;
  height: 130px;
  overflow: hidden;
  border-radius: 50%;
}

.circular--portrait img {
  width: 100%;
  height: auto;
}

.service {
  width: 150px;
  height: 150px;
  padding: 50%;
  background-color: #6d435a;
  color: #fff;
  border-radius: 50%;
  margin: 5px;
  border: solid 1px #fffcf9;
}
</style>